// @core/api/endpoints/task/update_container_config.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ContainerConfigResponse,
  UpdateContainerConfigRequest,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Update container config
 * Updates task configuration for a container. Changes apply to new tasks; existing tasks are not retroactively modified.
 */
export async function UpdateContainerConfig(
  config_id: string,
  data: UpdateContainerConfigRequest,
  options?: RequestOptions
): Promise<ContainerConfigResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/container-configs/:config_id`;
  requestPath = requestPath.replace(':config_id', encodeURIComponent(config_id));
  const requestOptions = options;
  return client.put<ContainerConfigResponse>(requestPath, data, requestOptions);
}
